import {
  InjectedExperimentsProps,
  withExperiments,
} from '@wix/wix-experiments-react';
import { PackagePickerType } from 'enums';
import { RootStore, withInjectedRootStore } from 'providers';
import * as React from 'react';
import { App } from '../App/App';
import { SandboxApp } from '../SandboxApp';
import { SunriseApp } from '../SunriseApp';
import { WixStudioApp } from '../WixStudioApp';
import '@wix/design-system/styles.global.css';

interface ClientComponentProps extends InjectedExperimentsProps {
  rootStore: RootStore;
}

export const ClientComponent: React.FC<ClientComponentProps> = ({
  experiments,
  rootStore,
}) => {
  const {
    isSunriseV2Enabled,
    shouldRenderWixStudioPackagePicker,
    appContext: { packagePickerType },
  } = rootStore.appStore;
  if (packagePickerType === PackagePickerType.Sandbox) {
    return <SandboxApp />;
  } else if (shouldRenderWixStudioPackagePicker) {
    return <WixStudioApp />;
  } else {
    return isSunriseV2Enabled ? <SunriseApp /> : <App />;
  }
};

export const Client = withInjectedRootStore(withExperiments(ClientComponent));
